import { useTranslation } from 'react-i18next';

import PageLayout from '@/components/Layout/PageLayout';

import type { HealthDetailPageId } from '../_config/healthDetailPageConfig';
import { getHealthDetailPageConfig } from '../_config/healthDetailPageConfig';
import HealthDetailDetections from '../components/HealthDetailDetections/HealthDetailDetections';
import HealthDetailInformationPanel from '../components/HealthDetailInformationPanel/HealthDetailInformationPanel';
import HealthDetailTemplate from '../components/HealthDetailTemplate/HealthDetailTemplate';
import HealthDevelopmentChart from '../components/HealthDevelopmentChart/HealthDevelopmentChart';
import HealthStatusChart from '../components/HealthStatusChart/HealthStatusChart';

import HealthWoundsBodySubTabBar from './components/HealthWoundsBodySubTabBar';
import HealthWoundsPrimaryTabBar from './components/HealthWoundsPrimaryTabBar';

export interface HealthWoundsDetailPageProps {
    pageId: Extract<HealthDetailPageId, 'bodyWounds' | 'snoutWounds'>;
}

export default function HealthWoundsDetailPage(props: HealthWoundsDetailPageProps) {
    const { pageId } = props;
    const { t } = useTranslation('healthModule');
    const pageConfig = getHealthDetailPageConfig(pageId);
    const showBodySubTabs = pageId === 'bodyWounds';

    return (
        <PageLayout title={t('routes.wounds')} subtitle={t('routes.health')}>
            <HealthWoundsPrimaryTabBar />
            {showBodySubTabs ? <HealthWoundsBodySubTabBar /> : null}
            <HealthDetailTemplate
                statusChart={
                    <HealthStatusChart healthParameterKey={pageConfig.healthParameterKey} />
                }
                developmentChart={
                    <HealthDevelopmentChart healthParameterKey={pageConfig.healthParameterKey} />
                }
                informationPanel={
                    <HealthDetailInformationPanel
                        healthParameterKey={pageConfig.healthParameterKey}
                        detailNamespace={pageConfig.detailNamespace}
                        routeLabelKey={pageConfig.routeLabelKey}
                    />
                }
                detections={
                    <HealthDetailDetections
                        healthParameterKey={pageConfig.healthParameterKey}
                        laksvelImageIndicator={pageConfig.laksvelImageIndicator}
                    />
                }
            />
        </PageLayout>
    );
}
